export const TRANSACTION_SCREENING_TABLE_HEADINGS = [
  'Transaction ID',
  'Date',
  'Transfer Method',
  'Partner Code',
  'Currency',
  'Amount',
  'Kyt Status',
  'Kyc Status',
  'Travel Rule Status',
  'Chainalysis Status',
];

export const PENDING_DEBIT_TRANSACTION_TITLE = 'Debit - Pending Transactions';
export const RFI_REQUESTED_DEBIT_TITLE = 'Debit - RFI Requested Transactions';

export const DEBIT_TRANSACTION_STATUSES = {
  IN_REVIEW: 'pending',
  RFI_REQUESTED: 'rfi_requested',
};

export const DEBIT_TXN_TAB_CONFIG = [
  {
    title: PENDING_DEBIT_TRANSACTION_TITLE,
    status: DEBIT_TRANSACTION_STATUSES.IN_REVIEW,
  },
  {
    title: RFI_REQUESTED_DEBIT_TITLE,
    status: DEBIT_TRANSACTION_STATUSES.RFI_REQUESTED,
  },
];
